import React from 'react';
import Typewriter from 'components/Typewriter';
import Scrollchor from 'react-scrollchor';

class Hero extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="hero-container">
        <Typewriter className="hero-title" text="Dhaval Singh" />
        <div className="hero-description">
          I am a software developer at Procol.
          <br />Check out my <Scrollchor to="#projects">
            projects
          </Scrollchor>{' '}
          below.
        </div>
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js